import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/crafts',
    name: 'POST_CRAFT',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
